/** One axis, one gap. The layout primitive every screen in the kit is built out of. */

import { createElement, type CSSProperties, type ElementType, type ReactNode } from "react";

import { cn } from "@/lib/cn";

import { mergeStyle, spaceVar, type SpaceStep } from "../internal/style";
import "./Stack.css";

export interface StackProps {
  /** A step on the 4px scale, so `gap={5}` is `--al-space-5`. */
  readonly gap?: SpaceStep;
  readonly direction?: "row" | "column";
  readonly align?: CSSProperties["alignItems"];
  readonly justify?: CSSProperties["justifyContent"];
  readonly wrap?: boolean;
  readonly as?: ElementType;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function Stack({
  gap,
  direction = "column",
  align,
  justify,
  wrap,
  as = "div",
  className,
  style,
  children,
}: StackProps) {
  return createElement(
    as,
    {
      className: cn("al-stack", className),
      style: mergeStyle(style, {
        flexDirection: direction,
        gap: spaceVar(gap),
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap === true ? "wrap" : undefined,
      }),
    },
    children,
  );
}
